import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'bv-browser-not-supported',
    templateUrl: './browser-not-supported.component.html',
    styleUrls: ['./browser-not-supported.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class BrowserNotSupportedComponent { }
